import { pickApi } from "./pick";

export const {
  useLazyGetPickQuery,
  useGetPicksQuery,
  useVerifyPickMutation,
  useCompletePickMutation,
  useSplitPickMutation
} = pickApi;
